import React from "react";
import TravelAssistanceSection from "../components/TravelAssistance/TravelAssistanceSection";
import TravelWithConfidence from "../components/TravelAssistance/TravelWithConifdence";
import EssentialServices from "../components/TravelAssistance/EssentialServicesEssentialServices";
import BackByGlobalTrust from "../components/TravelAssistance/BackByGlobalTrust";
import WhyYouNeedTravelSlider from "../components/TravelAssistance/WhyYouNeedTravelSlider";
import { Box } from "@mui/material";
import ServiceDescritive from "../components/TravelAssistance/ServiceDescritive";
import WhatOurCustomersSay from "../components/TravelAssistance/WhatOurCustomersSay";
import Header from "../layout/Header";
import banner1 from "../assets/Banner/WebBanner/HD travel.png";
import CustomerReviews from "../components/AutomobileAssistance/CustomerReviews";
import HeroSection from "../components/HeroSection";
import travelImg from "../assets/images/Travel/travel images.png";
import HomeAbout from "../components/Home/HomeAbout";
import BannerContent from "../components/BannerContent";
import NewsLetter from "../components/Home/NewsLetter";

const TravelAssistance = () => {
  return (
    <>
      <BannerContent
        bannerImage={banner1}
        title="Travel Assistance"
        subtitle="Wherever you go, we’ve got your back."
        containerStyles={{ background: "none" }}
        bannerHeight="400px"
      />

      {/* <HeroSection
        bannerImage={banner1}
        heading="Travel Assistance"
        description="Wherever your journey takes you, our travel assistance is with you 24/7. From lost passports and medical emergencies to language barriers and legal support, you’re never alone. Our global network connects you to expert guidance and practical solutions for any travel challenge."
        image={travelImg}
        gradientBg=""
        gradientOpacity={0.9}
      /> */}

      <HomeAbout />
      {/* <TravelWithConfidence /> */}
      <EssentialServices />
      {/* <BackByGlobalTrust /> */}
      <Box>
        <WhyYouNeedTravelSlider />
      </Box>

      {/* <Box>
        <ServiceDescritive />
      </Box> */}
      <Box>
        {/* <WhatOurCustomersSay /> */}
        <CustomerReviews />
      </Box>

      <NewsLetter />
    </>
  );
};

export default TravelAssistance;

const styles = {
  MainBannerBox: { overflow: "hidden", padding: "0px 0px" },
};
